module.exports = __webpack_public_path__ + "img/rotting_hay_cart_small.ca1772e0.png";